import React, { useContext, useState } from "react";
import TimeTableContext from "../../context/timeTableContext";
import QrReader from "react-qr-reader";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PersonIcon from "@material-ui/icons/Person";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import "./BarcodeReader.css";

const BarcodeReader = ({ change, clean }) => {
  const context = useContext(TimeTableContext);
  const [loading, setLoading] = useState(false);
  const [snackInfo, setSnackInfo] = useState({});
  const [openSnck, setOpenSnck] = useState(false);

  const handleCloseSnck = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnck(false);
  };

  const fetchUser = async (id) => {
    const currentUrl = new URL(window.location);

    const debug = currentUrl.searchParams.get("debug");
    const uuid = currentUrl.searchParams.get("uuid");

    if (id == null) return;
    const info = await fetch(
      `https://${
        debug ? "dev" : "my"
      }.schooly.co.il/has_corona_report?qrcode=${id}&uuid=${uuid}`,
    );

    setLoading(true);
    let infoParsed = await info.json();
    setSnackInfo(infoParsed);
    setOpenSnck(true);
    setLoading(false);
  };

  return (
    <div style={{ height: "100vh" }}>
      <div
        style={{
          position: "fixed",
          top: "20%",
          zIndex: "9999",
          width: "100%",
          textAlign: "center",
        }}
      >
        {loading && <CircularProgress size={100} />}
      </div>
      <i class="fab fa-500px"></i>
      <QrReader
        delay={300}
        onError={(e) => {
          console.log(e);
        }}
        onScan={(info) => {
          fetchUser(info);
        }}
        style={{ width: "100%", height: "100vh" }}
        className="qr-reader"
      />
      <Snackbar
        onClose={handleCloseSnck}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={openSnck}
        autoHideDuration={2000}
      >
        <SnackBarText info={snackInfo} />
      </Snackbar>
    </div>
  );
};

export default BarcodeReader;

const SnackBarText = ({ info }) => {
  console.log(info);
  return (
    <Alert
      style={{ width: "100%" }}
      severity={info.success ? "success" : "error"}
    >
      <h5>{info.success ? "יש הצהרה" : info.Msg}</h5>
      {info.success ? <AlertInfo info={info} /> : <br />}
    </Alert>
  );
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AlertInfo = (props) => {
  return (
    <div>
      <PersonIcon />
      {props.info.student_f_name}
      &nbsp; {props.info.student_l_name} - {props.info.classText}
      <br />
      <AssignmentIndIcon />
      {props.info.student_login_id}
    </div>
  );
};
